import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AssessmentAnswerSubmissionModel } from 'src/app/models/assessment/assessmentsubmission.model';
import { QuestionAnswer, QuestionDisplay } from 'src/app/models/assessment/newquestion.model';
import { BreadCrumb } from 'src/app/models/breadcrumb.model';
import { AssessmentmanagerService } from 'src/app/services/assessments/assessmentmanager.service';
import { ComponentheaderService } from 'src/app/services/componentheader.service';
import { NotificationService } from 'src/app/services/interceptor/notification';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'app-studentassessmentdetails',
  templateUrl: './studentassessmentdetails.component.html',
  styleUrls: ['./studentassessmentdetails.component.css']
})


export class StudentassessmentdetailsComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild("questionPane") questionPane: ElementRef;

  @ViewChild("fileUpload") fileUpload: ElementRef;

  @ViewChild("clock") clock: ElementRef;

  @ViewChild("buttonPane") buttonPane: ElementRef;


  assessment: any = {};
  assessmentname: string;
  assessmentID: number;
  moduleID: number;
  confirmAssessmentdelete = false;
  confirmQuestiondelete = false;
  errormessage: string;
  classID: number = 0;
  batchID: number = 0;
  loading: string;
  breadcrumbs: BreadCrumb[] = [];

  fileAnswer: File = null;
  fileQuestionDisplay: any;
  questionInView: QuestionDisplay = new QuestionDisplay();
  hideQuestionNavButton: number;
  CountDownTarget: Date = new Date();
  showClock = false;
  clockReady = false;
  intervalCountDown: any;
  submitinProgress: boolean = false;
  crumbitem: any;

  questions: any[];
  questionType: string;
  startTime: string;
  endTime: String;
  timedType: string;
  scored = false;
  questionCount = 0;
  showsubmit = false;
  score: any;
  marks: any;
  isDraft: any;
  submissionFileName: string;
  autoSaveIntervalId: any;
  essayTextExceeded: boolean;

  constructor(private activatedroute: ActivatedRoute, private toastr: ToastrService, private router: Router, public assessmentManager: AssessmentmanagerService,
    public sanitizer: DomSanitizer, public header: ComponentheaderService, private notification: NotificationService, private utilservice: UtilService) {

    this.assessmentname = "Loading Assessment..."
    this.header.setHeaderDisplay("Assessment Details", [], []);
  }

  async ngOnInit() {

  }

  async ngAfterViewInit() {
    this.header.pageLoadingStarted(this);

    this.assessmentID = this.activatedroute.snapshot.queryParams.aid;
    this.classID = this.activatedroute.snapshot.queryParams.classid;
    this.batchID = this.activatedroute.snapshot.queryParams.batchid;
    this.notification.currentNotificationType = this.notification.CALL_TYPE.SIMPLE_PAGE_LOAD_GET_CONTENT;
    let response: any
    try {
      response = await this.assessmentManager.getAssessmentDetails(this.assessmentID,this.batchID).toPromise();
    }
    catch {
      this.router.navigate(["/user/assessmentconsole"], { queryParams: { classid: this.classID,batchid:this.batchID } });
      return;
    }
    this.assessment = response.data;    
    this.assessmentname = response.data.name;
    this.crumbitem = response.breadcrumb;
    this.questionType = this.assessment.questionType;
    this.timedType = this.assessment.timedType;
    this.questions = this.assessment.questions
    this.startTime = this.assessment.startTime;
    this.endTime = this.assessment.endTime;
    this.score = this.assessment.score
    this.marks = this.assessment.marks
    this.questionCount = this.questions.length;
    this.isDraft = this.assessment.draft;
    this.scored = this.assessment.scored;
    this.moduleID = this.crumbitem.moduleID;
    
    // if(this.assessment.questionType === this.assessmentManager.QuestionTypeFlags.essayQuestionFlag && this.assessment.essaytextlimit > 0){
    //   if(this.assessment.questions.some(q => (q.stdAnswer?.length - 7) > this.assessment.essaytextlimit)){ //'(q.stdAnswer?.length - 7)' is done to accomodate for '<p></p>'. The tags should not be counted
    //     this.essayTextExceeded = true;
    //   }     
    // }
    this.header.setHeaderDisplay(`Assessment : ${this.crumbitem.assessmentName}`,
      [
        //   {displaytext: 'Home', route: '/user' },
        // { displaytext:  this.crumbitem.schoolName, route: `/user/schoolhome`, params: { schoolID: this.crumbitem.schoolID } },
        // { displaytext:  this.crumbitem.moduleName, route: `/user/moduledetails`, params: { moduleID: this.crumbitem.moduleID } },
        // { displaytext:  this.crumbitem.lessonName , route: `/user/lesson`, params: { classid: this.classID } },
        { displaytext: "Assessments", route: `/user/assessmentconsole`, params: { classid: this.classID ,batchid:this.batchID} },
        { displaytext: this.crumbitem.assessmentName, route: `/user/assessmentdetails`, params: { classid: this.classID, aid: this.assessmentID } }
      ],
      []);

    localStorage.setItem(this.assessmentManager.LocalStorage_FLAG.questionType, this.assessment.questionType);
    localStorage.setItem(this.assessmentManager.LocalStorage_FLAG.AssesmentTitle, this.assessment.name);
    localStorage.setItem(this.assessmentManager.LocalStorage_FLAG.deliveryType, response.data.timedType);
    localStorage.setItem(this.assessmentManager.LocalStorage_FLAG.currentAssessmentCache, JSON.stringify(response.data));

    //call this for only file assessments with only one questions
    


    this.header.setHeaderDisplay("Assessment Details",
      [
        { displaytext:  'School', route: `/user/schoolhome`, params: { schoolID: this.crumbitem.schoolID } },
        { displaytext:  'Course', route: `/user/moduledetails`, params: { moduleID: this.crumbitem.moduleID } },
        { displaytext:  'Lesson' , route: `/user/lesson`, params: { classid: this.classID } },
        { displaytext: "Assessments", route: `/user/assessmentconsole`, params: { classid: this.classID,batchid:this.batchID } },
        { displaytext: this.crumbitem.assessmentName, route: `/user/assessmentdetails`, params: { classid: this.classID,batchid: this.batchID, aid: this.assessmentID } }
      ], []
    )

    if (this.assessment.questionType == this.assessmentManager.QuestionTypeFlags.fileQuestionFlag) {
      const data: any = await this.assessmentManager.getAssessmentFile(this.assessment.questions[0].id, 0).toPromise();
      this.fileQuestionDisplay = data.files[0];
    }

    this.header.pageLoadingDone(this);

    //debugger;
    //let pane = this.questionPane.nativeElement as HTMLElement;

    if (this.assessment.questions.length > 0) {
      setTimeout(() => {
        this.getQuestionToShow(0);//putting this in setTimeout to allow the relevant controls to have been generated in the browser
      });
    }

    if (this.assessment.timedType == this.assessmentManager.DeliveryModeFlags.Timed) {
       let dateValue = new Date(Date.parse(this.assessment.examsessionendtimestring));

      let currentvalue = new Date(
        Date.parse(this.assessment.examsessioncurrenttime)
      );
      let endtime = dateValue.getTime();
      let current = currentvalue.getTime();
      if (endtime > current) {
        this.CountDownTarget = dateValue;

        this.showClock = true;

        // The countdown used to keep its own counter and add exactly 1000ms per tick. setInterval
        // is not precise, and browsers throttle timers in a background tab to roughly once a
        // minute — so switching tabs slowed or stopped the exam clock. Remaining time is now
        // measured against the real clock, using the offset between the server's current time and
        // the browser's, so a hidden tab cannot buy the student extra time.
        const serverOffset = current - Date.now();
        this.intervalCountDown = setInterval(() => {
          let duration = endtime - (Date.now() + serverOffset);
          if (duration < 0) { duration = 0; }

          let hours = Math.floor(
            (duration % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
          );
          let minutes = Math.floor((duration % (1000 * 60 * 60)) / (1000 * 60));
          let seconds = Math.floor((duration % (1000 * 60)) / 1000);

          let clockDisplay = `${hours}h ${minutes}m ${seconds}s`;

          let clockPane = this.clock?.nativeElement as HTMLElement;
          const clockElement = clockPane?.getElementsByClassName('clock').item(0);
          if (clockElement) {
            clockElement.innerHTML = clockDisplay;
          }

          //auto submit — the student is out of time, so whatever is answered is submitted
          if (duration <= 0 && this.submitinProgress == false) {
            this.submitinProgress = true;
            this.toastr.error('Time Has Elapsed');
            this.saveAssessment(false, false, true);
          }
        }, 1000);
        setTimeout(() => {
          //putting show clock here so that it displays the clock after the time display has been set
          this.clockReady = true;
        }, 1000);
      } 
      else if (!this.assessment.submitted) {
        this.toastr.error('Time Has Elapsed');
        this.router.navigate(['/user/assessmentconsole'], {
          queryParams: { classid: this.classID,batchid:this.batchID },
        });
      }
    }

    if(!this.assessment.submitted && this.assessment.questionType == this.assessmentManager.QuestionTypeFlags.essayQuestionFlag){
      this.saveDraftPeriodically();
    }

  }

  handleFileSelect(files: FileList) {
    this.fileAnswer = files[0];
    this.submissionFileName = this.fileAnswer.name;
  }

  saveDraftPeriodically() {
    this.autoSaveIntervalId = setInterval(async () => {
      await this.saveAssessment(true, true);
    }, 120000);
  }

  stopDraftPeriodicFunction() {
    clearInterval(this.autoSaveIntervalId);
  }

  /**
   * Stops the exam countdown once a submission is actually going out. A draft or an autosave
   * leaves it running — the student is still working.
   */
  stopTheClock(isdraft: boolean, autosave: boolean) {
    if (this.assessment.timedType != this.assessmentManager.DeliveryModeFlags.Timed) { return; }
    if (autosave || isdraft) { return; }
    this.CountDownTarget = new Date();
    clearInterval(this.intervalCountDown);
    this.showClock = false;
  }

  /**
   * @param timeExpired set only by the countdown. When the clock runs out the student is out of
   * time, so whatever has been answered must go — unanswered questions can no longer block it.
   */
  async saveAssessment(isdraft: boolean = false, autosave: boolean = false, timeExpired: boolean = false) {
    //stop the clock
    try{
      this.header.pageLoadingStarted(this);
      // The clock used to be stopped here, before the answers were read. A submission that then
      // failed validation left the student with no timer and nothing submitted. It now stops only
      // once the answers have been read and are actually going to be sent — see stopTheClock().
      this.submitinProgress = true;
      
      
      
      let questionAnswerString = [];
      let studentQuestionResponse = this.questionPane.nativeElement as HTMLElement;
      let questionAnswerObject;
      //handle multichoice business
      // `return` inside a forEach ends only that iteration, so an unreadable question used to be
      // skipped and the assessment submitted WITHOUT it — one error toast per bad question, and
      // the student marked wrong on answers that were never sent. For multiple choice an
      // *unanswered* question lands here too, because the placeholder option parses to NaN.
      // Collect the failures, then stop before submitting. Same fix as M07 F1 on the lesson page.
      const unreadableQuestions: number[] = [];

      if (this.assessment.questionType == this.assessmentManager.QuestionTypeFlags.multichoiceQuestionFlag) {
        let multichoiceSelectTags = studentQuestionResponse.getElementsByTagName("select");
        Array.from(multichoiceSelectTags).forEach((item, index) => {
          let optionId = Number.parseInt(item.value);
          let questionId = Number.parseInt(item.getAttribute("id"));
          if(Number.isNaN(questionId) || Number.isNaN(optionId)){
            unreadableQuestions.push(index + 1);
            return;
          }

          questionAnswerString.push( {
            optionID : optionId,
            questionID: questionId ,
            questiontype:this.assessmentManager.QuestionTypeFlags.multichoiceQuestionFlag,
            assessmentID: this.assessmentID
          });
        });
      }
      else if (this.assessment.questionType == this.assessmentManager.QuestionTypeFlags.essayQuestionFlag) {

        let essayQuilEditor = studentQuestionResponse.getElementsByClassName("ql-editor");

        Array.from(essayQuilEditor).forEach((item, index) => {
          let questionId = Number.parseInt(item.parentElement.parentElement.getAttribute("id"));
          if(Number.isNaN(questionId)){
            unreadableQuestions.push(index + 1);
            return;
          }

          questionAnswerString.push({
            AnswerText:item.innerHTML,
            questionID: questionId,
            questiontype: this.assessmentManager.QuestionTypeFlags.essayQuestionFlag,
            assessmentID: this.assessmentID
        });
        });

      }

      else if (this.assessment.questionType == this.assessmentManager.QuestionTypeFlags.fileQuestionFlag) {
        let fileItem = this.fileUpload.nativeElement as HTMLInputElement;

        const toBase64 = file => new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result);
          reader.onerror = error => reject(error);
        });       

        let FileFormData = new FormData();
        if(this.fileAnswer === null && this.fileQuestionDisplay){
          FileFormData = null;
          let confirm = false;
          confirm = await this.utilservice.confirm('You have not selected a file', 'If you continue, your saved draft will be submitted. <br />Do you wish to continue?', true);
          if(!confirm)
            return;
        }
        else{
          FileFormData.append('file', this.fileAnswer, this.fileAnswer.name);
        }

        try{
          const data: any = await this.assessmentManager.submitFileUploadAssessment(FileFormData, Number.parseInt(fileItem.getAttribute("id")), isdraft, this.moduleID).toPromise();
          this.afterSubmitActions(autosave, isdraft);
        }
        catch(error){
          console.error(error);
          this.toastr.error('An error occured');
        }
        finally{
          this.stopTheClock(isdraft, autosave);
        }
      }

      // An autosave must never interrupt the student with a message, and must never submit a
      // partial set — it just skips this round and tries again in two minutes. When the clock has
      // run out the student is out of time, so the answers they do have are submitted regardless.
      if (unreadableQuestions.length > 0 && !timeExpired) {
        if (autosave) {
          return;
        }
        this.toastr.error(
          unreadableQuestions.length === 1
            ? `Question ${unreadableQuestions[0]} has not been answered. Please answer it before submitting.`
            : `Questions ${unreadableQuestions.join(', ')} have not been answered. Please answer them before submitting.`
        );
        return;
      }

      if (questionAnswerString.length > 0) {
        //this.header.pageLoadingStarted(this);

        let jsonQuestionAnswerString = JSON.stringify(questionAnswerString)
        
        questionAnswerObject = JSON.parse(jsonQuestionAnswerString);

        let submissionModel = new AssessmentAnswerSubmissionModel();
        submissionModel.questionanswerobject = questionAnswerObject
        submissionModel.isdraft = isdraft;
        submissionModel.moduleID = this.moduleID;

        try{
          const data = await this.assessmentManager.submitAssessment(submissionModel).toPromise();
          this.afterSubmitActions(autosave, isdraft);
        }
        catch(error){
          console.error(error);
          this.toastr.error(error?.error?.message || 'An error occured');
        }
        finally{
          this.stopTheClock(isdraft, autosave);
        }

      }
      else {
        if (this.assessment.questionType != this.assessmentManager.QuestionTypeFlags.fileQuestionFlag) { this.toastr.warning("Error Submitting Assessment : No Data found"); }

        this.stopTheClock(isdraft, autosave);
      }
    }
    finally{
      this.header.pageLoadingDone(this);
      this.submitinProgress = false;
    }
  }

  afterSubmitActions(autosave: boolean, isdraft: boolean){
    if(!autosave){
      if (isdraft)
        this.toastr.success("Draft Saved");
      else
        this.toastr.success("Assessment Submitted");
    }
    if(!isdraft)
      this.router.navigate(['/user/assessmentconsole'], { queryParams: {classid: this.classID,batchid:this.batchID}});
  }
  //for the single display pattern
  // getQuestionToShow(questionIndex:number){

  //   if(questionIndex < this.assessment.questions.length && questionIndex > -1){
  //     let questionAtIndex = this.assessment.questions[questionIndex]
  //     this.questionInView.marks = questionAtIndex.marks;
  //     this.questionInView.answeredText = questionAtIndex.stdAnswer;
  //     this.questionInView.index = questionIndex + 1;
  //     this.questionInView.next = questionIndex + 1;
  //     this.questionInView.previous = questionIndex - 1;
  //     this.questionInView.questionId = questionAtIndex.id;
  //     this.questionInView.questionText = questionAtIndex.text;

  //     console.log(this.questionInView);
  //   }else{
  //     //return an empty question
  //     //hide previous
  //     //show end
  //   }
  // }

  getQuestionToShow(questionIndex: number) {        
    let questionsContainer = this.questionPane.nativeElement as HTMLElement;
    let buttonContainer = this.buttonPane.nativeElement as HTMLElement;

    let allquestion = questionsContainer.getElementsByTagName("li");

    let questionItemNavButtons = buttonContainer.getElementsByClassName("questionBadge");

    let questionListLenght = this.assessment.questions.length;

    //hide nextbutton
    if (questionIndex == questionListLenght || questionIndex == questionListLenght - 1) {
      this.hideQuestionNavButton = 1;
      this.showsubmit = true;
    }
    //hide previus button
    else if (questionIndex <= 0) {
      this.hideQuestionNavButton = 2;
      this.showsubmit = false;
    }
    else {
      this.hideQuestionNavButton = 0;
      this.showsubmit = false;
    }

    if (questionIndex < questionListLenght && questionIndex > -1) {
      Array.from(allquestion).forEach((item, index) => {
        item.classList.add("ghostquestion");
        if(questionItemNavButtons.length > 0){
          questionItemNavButtons.item(index).classList.remove("questionBadge_active");
        }
      });
      let questionToShow = allquestion.item(questionIndex)
      questionToShow.classList.remove("ghostquestion");

      let questionAtIndex = this.assessment.questions[questionIndex]
      this.questionInView.marks = questionAtIndex.marks;
      this.questionInView.answeredText = questionAtIndex.stdAnswer;
      this.questionInView.index = questionIndex + 1;
      this.questionInView.next = questionIndex + 1;
      this.questionInView.previous = questionIndex - 1;
      this.questionInView.questionId = questionAtIndex.id;
      this.questionInView.questionText = questionAtIndex.text;

      if(questionItemNavButtons.length > 0){
        questionItemNavButtons.item(questionIndex).classList.add("questionBadge_active");
      }


    } else {
      //return an empty question
      //hide previous
      //show end
    }

    if(this.assessment.submitted)
      this.showsubmit = false;
  }

  async togglepopup(){
    let confirm = await this.utilservice.confirm('Previous Assessment record will be deleted permanently', 'Do you wish to continue?');
    if(confirm){
      this.retakeAssessment();
    }
  }

  retakeAssessment(){
    this.header.pageLoadingStarted(this);
    this.assessmentManager.deleteSubmittedAssessmentByStudent(this.assessmentID, this.assessment.submissionid, this.classID).subscribe(
      (data: any) => {
        this.toastr.success("Assessment can now be retaken");
        this.router.navigate(["/user/assessmentconsole"], { queryParams: { classid: this.classID,batchid:this.batchID } });
      },
      (error : any) => {
        console.error(error);
        this.toastr.error('An error occured');
      },
      () => {
        this.header.pageLoadingDone(this);
      }
    )
  }

  handleTextExceeded(data: any) {    
    this.essayTextExceeded = data.exceed;
    let q = this.questions.find(question => question.id === data.id);
    // this is used for updating the pagination buttons to indicate red
    q.isValid = data.exceed ? 0 : 1;
  }
  ngOnDestroy() {
    this.stopDraftPeriodicFunction();
    // Only the autosave interval was cleared here. The 1-second exam countdown was left running
    // for the rest of the session on a destroyed component — writing into a detached element and
    // able to auto-submit an assessment the student had already left. Every timed assessment
    // opened added another one.
    clearInterval(this.intervalCountDown);
  }
}
